import React from 'react';

export default function InstallmentPayments({
  installmentData,
  order,
  isInst,
  cancelAndRefundView,
  setCancelAndRefundView,
}) {
  const scheduledInstallments = installmentData?.filter(
    inst => inst.status === 'p' || inst.status === 'pc'
  );
  return (
    <div className="col-md-12 client-details">
      <div className="client-info">
        <div className="card shadow-sm">
          <div
            className="card-header d-flex justify-content-between align-items-center"
            style={{backgroundColor: '#404040'}}
          >
            <h5 className="mb-0" style={{color: 'white'}}>
              Installment Payments
            </h5>
            {installmentData?.some(inst => inst.status === 'u' || inst.status === 'm') && (
              <button
                type="button"
                className="btn cf-btn btn-pink"
                onClick={() => {
                  window.open(`/installment-card-update/${order?.uuid}`, '_blank');
                }}
              >
                Update Payment Information
              </button>
            )}
          </div>
          <div className="card-body">
            <div className="mt-3 table-responsive table-fixed">
              <table className="table _tableCommon">
                <thead>
                  <tr>
                    <th>Payment Date(s)</th>
                    <th>Payment Amount</th>
                    <th>Payment Status</th>
                    <th>Card</th>
                    <th>Square Payment Status</th>
                    <th>Square Receipt</th>
                    {/* <th>Square Fees</th>
                    <th>Platform Fees</th>
                    <th>Coach Proceeds</th>
                    <th>Refunded Amount</th> */}
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    // Group installments by sqPaymentId
                    const groupedByPaymentId = {};
                    installmentData.forEach(item => {
                      const key = item.sqPaymentId || `no_id_${item.dt}_${item.amt}`;
                      if (!groupedByPaymentId[key]) {
                        groupedByPaymentId[key] = [];
                      }
                      groupedByPaymentId[key].push(item);
                    });

                    return Object.keys(groupedByPaymentId).map((paymentId, index) => {
                      const group = groupedByPaymentId[paymentId];
                      const isMultiple = group.length > 1;

                      const sortedDates = group
                        .map(g => {
                          // Parse dt as UTC (assuming dt is an ISO string like "2025-06-06" or "2025-06-06T16:04:00Z")
                          const date = new Date(g.dt);
                          // Use UTC methods to avoid local time zone offset
                          const mm = date.getUTCMonth() + 1; // Months are 0-based
                          const dd = date.getUTCDate();
                          const yyyy = date.getUTCFullYear();
                          return `${mm.toString().padStart(2, '0')}/${dd
                            .toString()
                            .padStart(2, '0')}/${yyyy}`;
                        })
                        .sort((a, b) => new Date(a) - new Date(b)) // Sort dates as strings or convert to Date for sorting
                        .join(', ');
                      const squareData = group.find(g => g.square)?.square || null;
                      const statuses = group.map(g => g.status);

                      const missed = statuses.some(
                        st => st === 'm' || (squareData && squareData.reason)
                      );
                      const paid = statuses.some(st => st === 'pc' || st === 'p');
                      const scheduled = statuses.some(st => st === 'u');
                      const refunded = statuses.some(st => st === 'rf');
                      const cancelled = statuses.some(st => st === 'cancelled');
                      let refund;
                      if (statuses.every(st => st === 'rf')) {
                        refund = 'Refunded';
                      } else if (statuses.some(st => st === 'rf')) {
                        refund = 'Partially Refunded';
                      } else {
                        refund = '';
                      }

                      // Payment status display
                      let paymentStatusDisplay;
                      if (missed) {
                        paymentStatusDisplay = (
                          <span style={{color: 'red'}}>
                            <b>Missed Payment</b>
                          </span>
                        );
                      }
                      if (paid) {
                        paymentStatusDisplay = (
                          <span style={{color: 'green'}}>
                            <b>Paid</b>
                          </span>
                        );
                      }
                      if (scheduled) {
                        paymentStatusDisplay = (
                          <span style={{color: 'grey'}}>
                            <b>Scheduled</b>
                          </span>
                        );
                      }
                      if (refunded) {
                        paymentStatusDisplay = (
                          <span style={{color: 'green'}}>
                            <b>{refund}</b>
                          </span>
                        );
                      }
                      if (cancelled) {
                        paymentStatusDisplay = (
                          <span style={{color: 'red'}}>
                            <b>Cancelled</b>
                          </span>
                        );
                      }
                      const reasons = group
                        .filter(g => g.square?.reason)
                        .map(g => g.square.reason)
                        .join(', ');
                      let refundedMoney = '';
                      if (squareData?.refunded_money) {
                        refundedMoney = squareData.refunded_money?.amount / 100;
                        if (refundedMoney) {
                          refundedMoney = refundedMoney.toFixed(2);
                        }
                      }
                      // Payment amount
                      let rawTotalMoney;
                      if (squareData?.total_money) {
                        rawTotalMoney = squareData.total_money / 100;
                      } else {
                        // Fallback: sum all installment amounts in this group
                        rawTotalMoney = group.reduce((sum, g) => sum + g.amt, 0);
                      }
                      const totalMoney = parseFloat(rawTotalMoney.toFixed(2));

                      // For the multi-installment info label
                      const installmentsInfo = isMultiple ? (
                        <span style={{marginLeft: '8px', color: 'orange', fontWeight: 'bold'}}>
                          <br />
                          (Includes {group.length} installments)
                        </span>
                      ) : null;

                      // Fees & proceeds if square data is completed
                      const processingFee = squareData?.processing_fee
                        ? (squareData.processing_fee / 100).toFixed(2)
                        : null;
                      const platformFee =
                        squareData?.status === 'COMPLETED' && squareData.app_fee_money
                          ? (squareData.app_fee_money / 100).toFixed(2)
                          : null;
                      const coachProceeds =
                        squareData && squareData.status === 'COMPLETED'
                          ? (
                              (squareData.total_money -
                                squareData.processing_fee -
                                squareData.app_fee_money) /
                              100
                            ).toFixed(2)
                          : null;

                      return (
                        <tr key={index}>
                          <td>{sortedDates}</td>
                          <td>
                            <i className="fa fa-usd"></i> {Number(totalMoney).toFixed(2)}
                            {installmentsInfo}
                          </td>
                          <td>
                            {paymentStatusDisplay}
                            {reasons && <span style={{color: 'grey'}}> {reasons}</span>}
                          </td>
                          <td>
                            {squareData && (
                              <>
                                {squareData?.last_4 && <span>** ** ** {squareData.last_4}</span>}
                                {squareData?.exp_month && (
                                  <>
                                    {squareData?.last_4 && <span>, </span>}
                                    <span>
                                      <b>Exp.</b>: {squareData.exp_month}
                                    </span>
                                  </>
                                )}
                                {squareData?.exp_year && (
                                  <>
                                    {squareData?.last_4 || squareData?.exp_month ? (
                                      <span>/</span>
                                    ) : null}
                                    <span>{squareData.exp_year}</span>
                                  </>
                                )}
                                {squareData?.card_brand && (
                                  <>
                                    {(squareData?.last_4 ||
                                      squareData?.exp_month ||
                                      squareData?.exp_year) && <span>, </span>}
                                    <span>
                                      <b>{squareData.card_brand}</b>
                                    </span>
                                  </>
                                )}
                              </>
                            )}
                          </td>
                          <td>
                            {squareData && (
                              <span
                                style={{color: squareData.status === 'COMPLETED' ? 'green' : 'red'}}
                              >
                                <b>
                                  {squareData?.refunded_money?.amount
                                    ? refund.toUpperCase()
                                    : squareData.status}
                                </b>
                              </span>
                            )}
                          </td>
                          <td>
                            {squareData && (
                              <a
                                style={{color: 'red'}}
                                target="_blank"
                                rel="noreferrer"
                                href={squareData.receipt_url}
                              >
                                {squareData.receipt_url ? 'Receipt' : 'N/A'}
                              </a>
                            )}
                          </td>
                          {/* <td>
                            {processingFee && (
                              <>
                                <i className="fa fa-usd"></i> {processingFee}
                              </>
                            )}
                          </td>
                          <td>
                            {platformFee && (
                              <>
                                <i className="fa fa-usd"></i> {platformFee}
                              </>
                            )}
                          </td>
                          <td>
                            {coachProceeds && (
                              <>
                                <i className="fa fa-usd"></i> {coachProceeds}
                              </>
                            )}
                          </td>
                          <td>
                            {refundedMoney ? '$' : ''}
                            {refundedMoney}
                          </td> */}
                        </tr>
                      );
                    });
                  })()}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
